var socialIcon = {
  socialUrl: 'https://www.facebook.com/NationalVeterinaryAssociates',
  socialIconType: 'Facebook'
};
export { socialIcon };